<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
    v-card
      v-card-title.px-4
        v-btn(icon color="neutral700" @click="closeDialog")
          v-icon mdi-arrow-left
        v-spacer
        .text-md.font-semibold.ml-n4 To do
        v-spacer
      v-divider
      v-card-text
        profile.mt-4.mb-8(:member-id="profile.id" :name="profile.name" :phone="profile.phone" :email="profile.email" :dob="profile.dob")
        todo-items.my-8(:loyaltySystem="loyaltySystem" :profile="profile" @backToCollectPage="closeDialog" @redeemed="$emit('redeemed')")
        redeem-offer.my-8(:profile="profile" @backToHomepage="closeDialog")
</template>

<script>
import Profile from "@/components/marketing/merchantapp/todo/Profile.vue";
import TodoItems from "@/components/marketing/merchantapp/todo/TodoItems.vue";
import RedeemOffer from "@/components/marketing/merchantapp/offer/RedeemOffer.vue";

export default {
  components: {
    RedeemOffer,
    TodoItems,
    Profile
  },
  props: {
    open: {
      type: Boolean,
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    closeDialog() {
      this.showDialog = false
      this.$emit('close')
    }
  },
}
</script>

<style scoped>
</style>
